import { useState } from "react";
import Fields from "../Utilities/Fields"

function GetFields() {
    const [fieldsJson, setFieldsJson] = useState("");
    const [fieldName, setFieldName] = useState("");

    return <div>
        <h1>Get Fields on an object</h1>
        <br></br>
        <h2>Desired Object Name:</h2><input value={fieldName} onChange={(event) => setFieldName(event.target.value)}></input>
        <br></br>
        <h2>Paste the following into the "Execute SOQL Query" method and press run</h2>
        <br></br>
        <p><em>SELECT EntityDefinition.QualifiedApiName, QualifiedApiName, DataType FROM FieldDefinition WHERE EntityDefinition.QualifiedApiName = '{fieldName}'</em></p>
        <br></br>
        <h2>Paste the resulting json into this box and press submit, your file will be downloaded</h2>
        <fieldset>
            <textarea value={fieldsJson} onChange={(event) => setFieldsJson(event.target.value)}></textarea><br/>
            <Fields data={fieldsJson}></Fields>
        </fieldset>
    </div>
}

export default GetFields